<script setup>
const onClick = () => {
    window.open('http://support.omcore.net/home/')
}
</script>

<template>
    <button
        class="btn btn-light btn-sm"
        @click="onClick"
    >
        Documentation
    </button>
</template>